module.exports = __webpack_public_path__ + "ea8255f0216caca50f3fd5f3cf852914.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-16.png
// module id = 112
// module chunks = 0